import { Container, Row, Col, Card, Button,Nav,Pagination, Carousel } from "@themesberg/react-bootstrap";
import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router";
import { Routes } from "../routes";
import queryString from "query-string";
import { FormattedMessage } from "react-intl";
import { authFetch } from "../auth";
import ProfileImg from "../assets/img/profile-cover.jpg";

const HomeDisplayItem = ({ item }) => {

  if(item.Content == undefined)
    item.Content = "Some quick example text to build on the card title and make up the bulk of the card's content."

  if(item.logo == undefined)
    item.logo = "profile-cover.jpg"

  return (
    <Card className="mx-2 mb-4 pt-2" style={{ flexBasis: "22%" }}>
      <Card.Img variant="top" src={item.logo} />
      <Card.Body>
        <Card.Title
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            WebkitLineClamp: "3",
            WebkitBoxOrient: "vertical",
            display: "-webkit-box",
          }}
        >
          {item.Name}
        </Card.Title>
        <Card.Text
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            WebkitLineClamp: "3",
            WebkitBoxOrient: "vertical",
            display: "-webkit-box",
          }}
        >
          Keyword : {item.keyword}
        </Card.Text>
        <Card.Text
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            WebkitLineClamp: "3",
            WebkitBoxOrient: "vertical",
            display: "-webkit-box",
          }}
        >
          Category : {item.main} &gt; {item.middle} &gt; {item.sub} &gt; {item.division} &gt; {item.subDivision}
        </Card.Text>
        <Card.Text
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            WebkitLineClamp: "3",
            WebkitBoxOrient: "vertical",
            display: "-webkit-box",
          }}
        >
          Content : {item.Content}
        </Card.Text>
        <Card.Text
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            WebkitLineClamp: "3",
            WebkitBoxOrient: "vertical",
            display: "-webkit-box",
          }}
        >
          Click : {item.click}
        </Card.Text>
        <Button
          variant="outline-primary"
          href={
            Routes.CompInfo.path + "?index=" + item._index + "&id=" + item._id
          }
        >
          <FormattedMessage id="more" />
        </Button>
      </Card.Body>
    </Card>
  );
};

export function setSearchResult(result) {
  // console.log("setSearchResult");
  /*
  const [list, setList] = useState([]);
  list.forEach((item) => {
    console.log(item);
  });

  useEffect(() => {
    fetch("/api/company", {
      method: "get",
    })
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp) {
          setList(resp);
        }
      });
  }, []);

  return (
    <Container fluid className="my-2">
      <Row xs={1} md={2} lg={4} className="g-4 justify-content-center">
        {list.length &&
          list.map((item) => <HomeDisplayItem item={item} key={item._index} />)}
      </Row>
    </Container>
  );
*/
}

export default (props) => {
  const location = useLocation();
  const query = queryString.parse(location.search);

  const searchInfo = query.searchInfo;
  const searchText = query.searchText;
  const searchGruop = query.searchGruop;

  const searchCountry = query.searchCountry;
  const searchCompany = query.searchCompany;
  const searchPri = query.searchPri;
  // const searchItem = query.searchItem;
  const useCategory = query.useCategory;

  const [list, setList] = useState([]);

  const [pageList, setPageList] = useState([]);
  const [firstList, setFirstList] = useState([]);

  let [currentPage, setCurrentPage] = useState(1);
  let [pageCount, setpageCount] = useState(1);
  let [total, setTotal] = useState(1);

  const history = useHistory();

  //let [itemsList, setItemsList] = useState([]);

  let items = [];

  let paginationItem = [];

  var data_array = [];
  var page_index = 0;
  var page_cnt = 1;

  const paginationClicked = (event) => {

    // console.log("paginationClicked 1");

    let enterVal = event.target.text;

    var newPage = 0;

    if(enterVal == "<<")
    {
      newPage = 1;
    }
    else if(enterVal == "<")
    {
      if(currentPage != 1)
      {
        newPage = currentPage - 1;
      }
      else
      {
        newPage = 1;
      }
    }
    else if(enterVal == ">")
    {
      if(currentPage != pageCount)
      {
        newPage = currentPage + 1;
      }
      else
      {
        newPage = currentPage;
      }
    }
    else if(enterVal == ">>")
    {
      newPage = pageCount;
    }
    else {
      newPage = parseInt(event.target.getAttribute('page'));
    }
    setCurrentPage(newPage);

    var itemClicked = newPage;

    setPageList([]);

    var data_list = [];

    //var items = [];

    if(itemClicked.toString() == "NaN"){
      
      /*
      for(var index = 0; index < 24; index++){
        // console.log(firstList);
        data_list.push(firstList[index]);
      }
      */

      authFetch(process.env.REACT_APP_API_URL + "/api/company/search?Page=" + 1, {
        method: "get",
      })
        .then((resp) => resp.json())
        .then((resp) => {
          if (resp) {
            for(var index = 0; index < 24; index++){
              setPageList(resp);
            }
          }
      });

    } else {
      // console.log(list);

      /*
      for(var index = 0; index < 24; index++){
        if(list[itemClicked * 24 + index] != undefined)
          data_list.push(list[(itemClicked - 1) * 24 + index]);
      }
      */

      authFetch(process.env.REACT_APP_API_URL + "/api/company/search?Page=" + newPage, {
        method: "get",
      })
        .then((resp) => resp.json())
        .then((resp) => {
          if (resp) {
            setPageList(resp);
          }
      });

    }
    
    //setItemsList(items);
    //setPageList(data_list);

    // console.log(data_list);
  }
  

  useEffect(() => {
    authFetch(process.env.REACT_APP_API_URL + "/api/company/count", {
      method: "get",
    })
      .then((resp) => resp.json())
      .then((resp) => {
        setTotal(resp["total"]);
        page_cnt = parseInt(resp["total"] / 24);

        if((page_cnt * 24) != resp["total"])
          page_cnt = page_cnt + 1;

        setpageCount(page_cnt);
    });

    if (searchInfo != undefined && searchText != undefined) {
      // console.log("search Info");

      authFetch("api/searchSimple", {
        method: "post",
        body: JSON.stringify({
          searchInfo,
          searchText,
          useCategory,
        }),
      })
        .then((resp) => resp.json())
        .then((resp) => {
          if (resp) {
            setList(resp);
            setTotal(resp.length);

            // console.log(resp);
            page_cnt = parseInt(resp.length / 24);

            if((page_cnt * 24) != resp.length)
              page_cnt = page_cnt + 1;

            setpageCount(page_cnt);

            if(resp.length != 0)
            {
              setPageList([]);

              var data_list = [];
              var total_list = [];

              for(var index = 0; index < 24; index++){
                if(resp[page_index * 24 + index] != undefined)
                  data_list.push(resp[page_index * 24 + index]);
                //pageList.push(resp[page_index * 24 + index]);
              }

              for(var index = 0; index < resp.length; index++){
                total_list.push(resp[index]);
                //pageList.push(resp[page_index * 24 + index]);
              }

              //var items = [];
              setFirstList(data_list);

              //setItemsList(items);
              setPageList(data_list);
            
            }
          }
        });
    } else if (
      searchCountry != undefined ||
      searchCompany != undefined ||
      searchPri != undefined
      // || searchItem != undefined
    ) {
      authFetch("api/Detailsearch", {
        method: "post",
        body: JSON.stringify({
          searchCountry,
          searchCompany,
          searchPri,
          // searchItem,
        }),
      })
        .then((resp) => resp.json())
        .then((resp) => {
          if (resp) {
            setList(resp);
            setTotal(resp.length);

            page_cnt = parseInt(resp.length / 24);

            if((page_cnt * 24) != resp.length)
              page_cnt = page_cnt + 1;

            setpageCount(page_cnt);

            if(resp.length != 0)
            {
              setPageList([]);

              var data_list = [];
              var total_list = [];

              for(var index = 0; index < 24; index++){
                if(resp[page_index * 24 + index] != undefined)
                  data_list.push(resp[page_index * 24 + index]);
                //pageList.push(resp[page_index * 24 + index]);
              }

              for(var index = 0; index < resp.length; index++){
                total_list.push(resp[index]);
                //pageList.push(resp[page_index * 24 + index]);
              }

              //var items = [];
              setFirstList(data_list);

              //setItemsList(items);
              setPageList(data_list);
            
            }
          }
        });
    } else if (
      searchGruop != undefined
      // || searchItem != undefined
    ) {
      authFetch("api/searchGruop", {
        method: "post",
        body: JSON.stringify({
          "searchCompany" : searchGruop,
        }),
      })
        .then((resp) => resp.json())
        .then((resp) => {
          if (resp) {
            // console.log(resp);
            setList(resp);
            setTotal(resp.length);

            page_cnt = parseInt(resp.length / 24);

            if((page_cnt * 24) != resp.length)
              page_cnt = page_cnt + 1;

            setpageCount(page_cnt);

            if(resp.length != 0)
            {
              setPageList([]);

              var data_list = [];
              var total_list = [];

              for(var index = 0; index < 24; index++){
                if(resp[page_index * 24 + index] != undefined)
                  data_list.push(resp[page_index * 24 + index]);
                //pageList.push(resp[page_index * 24 + index]);
              }

              for(var index = 0; index < resp.length; index++){
                total_list.push(resp[index]);
                //pageList.push(resp[page_index * 24 + index]);
              }

              //var items = [];
              setFirstList(data_list);

              //setItemsList(items);
              setPageList(data_list);
            
            }
          }
      });
    } else {
      // console.log("search All");

      authFetch(process.env.REACT_APP_API_URL + "/api/company/search", {
        method: "get",
      })
        .then((resp) => resp.json())
        .then((resp) => {
          if (resp) {
            setList(resp);

            //page_cnt = parseInt(resp.length / 24);

            if(resp.length != 0)
            {
              setPageList([]);

              var data_list = [];
              var total_list = [];

              for(var index = 0; index < 24; index++){
                if(resp[page_index * 24 + index] != undefined)
                  data_list.push(resp[page_index * 24 + index]);
                //pageList.push(resp[page_index * 24 + index]);
              }

              for(var index = 0; index < resp.length; index++){
                total_list.push(resp[index]);
                //pageList.push(resp[page_index * 24 + index]);
              }

              //var items = [];
              setFirstList(data_list);

              //setItemsList(items);
              setPageList(data_list);
            
            }

        }
      });
    }
  }, [searchCompany, searchCountry, searchInfo, searchPri, searchText]);

  const onButton1Click = () => {
    //setShow((prev) => !prev);
    var querySearch_Info =
    "/search-result?searchInfo=" + 5 + "&searchText=" + "46443";
    history.push(querySearch_Info);
    window.location.reload();
  };

  const onButton2Click = () => {
    //setShow((prev) => !prev);
    var querySearch_Info =
    "/search-result?searchInfo=" + 5 + "&searchText=" + "10";
    history.push(querySearch_Info);
    window.location.reload();
  };

  const onButton3Click = () => {
    //setShow((prev) => !prev);
    var querySearch_Info =
    "/search-result?searchInfo=" + 5 + "&searchText=" + "70";
    history.push(querySearch_Info);
    window.location.reload();
  };

  var first_mark = "<<";
  var priv_mark = "<";
  var next_mark = ">";
  var last_mark = ">>";

  var now_items_cnt = 1;

  items.push(<Pagination.Item page={first_mark} key={first_mark} onClick={(event) => paginationClicked(event)} >{first_mark}</Pagination.Item>);
  items.push(<Pagination.Item page={priv_mark} key={priv_mark} onClick={(event) => paginationClicked(event)} >{priv_mark}</Pagination.Item>);

  items.push(<Pagination.Item page={1} onClick={(event) => paginationClicked(event)} key={1}
      active={currentPage === 1}>{1}</Pagination.Item>);

  for (let i = 2; i <= pageCount; i++) {
    items.push(<Pagination.Item page={i} onClick={(event) => paginationClicked(event)} key={i}
      active={currentPage === i}>{i}</Pagination.Item>);

    now_items_cnt = now_items_cnt + 1;

    if((now_items_cnt % 20) == 0)
    {
      paginationItem.push(<Nav><Pagination>{items}</Pagination></Nav>);
      now_items_cnt = 0;
      items = [];
    }
    else if(i == pageCount)
    {
      items.push(<Pagination.Item page={next_mark} key={next_mark} onClick={(event) => paginationClicked(event)} >{next_mark}</Pagination.Item>);
      items.push(<Pagination.Item page={last_mark} key={last_mark} onClick={(event) => paginationClicked(event)} >{last_mark}</Pagination.Item>);
      paginationItem.push(<Nav><Pagination>{items}</Pagination></Nav>);
    }
  }

  if(pageCount == 1) {
    items.push(<Pagination.Item page={next_mark} key={next_mark} onClick={(event) => paginationClicked(event)} >{next_mark}</Pagination.Item>);
    items.push(<Pagination.Item page={last_mark} key={last_mark} onClick={(event) => paginationClicked(event)} >{last_mark}</Pagination.Item>);
    paginationItem.push(<Nav><Pagination>{items}</Pagination></Nav>);
  }

  return (
    <Container fluid className="pl-5" style={{ minHeight: "615px" }}>
      <Carousel>
        <Carousel.Item>
            <img
              className="d-block w-100"
              src='https://mdbootstrap.com/img/Photos/Slides/img%20(15).jpg'
              alt="First slide"
            />
          <Carousel.Caption>
            <h3>(주)유라스텍</h3>
            <p>(주)유라스텍 홍보 링크</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="https://mdbootstrap.com/img/Photos/Slides/img%20(22).jpg"
            alt="Second slide"
          />

          <Carousel.Caption>
            <h3>러시아 소식</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="https://mdbootstrap.com/img/Photos/Slides/img%20(23).jpg"
            alt="Third slide"
          />

          <Carousel.Caption>
            <h3>중앙 아시아</h3>
            <p>
              박람회 소개
            </p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
      {localStorage.getItem("lang") == "ru" ? (
      <Row className="text-center d-flex align-items-center justify-content-center mt-5">
        <Col lg={3} className="p-1">
          <Button type="button" onClick={onButton1Click} className="w-100">
            Список российских оптовиков косметики
          </Button>
        </Col> 
        <Col lg={3} className="p-1">
          <Button type="button" onClick={onButton2Click} className="w-100">
            Список российских компаний-производителей продуктов питания
          </Button>
        </Col>
        <Col lg={3} className="p-1">
          <Button type="button" onClick={onButton3Click} className="w-100">
            Список компаний российских НИИ
          </Button>
        </Col>
      </Row>
      ) : localStorage.getItem("lang") == "en-US" ? (
      <Row className="text-center d-flex align-items-center justify-content-center mt-5">
        <Col lg={3} className="p-1">
          <Button type="button" onClick={onButton1Click} className="w-100">
            List of Russian Cosmetics Wholesalers
          </Button>
        </Col> 
        <Col lg={3} className="p-1">
          <Button type="button" onClick={onButton2Click} className="w-100">
            List of Russian Food Manufacturing Companies
          </Button>
        </Col>
        <Col lg={3} className="p-1">
          <Button type="button" onClick={onButton3Click} className="w-100">
            List of Russian Research Institute Companies
          </Button>
        </Col>
      </Row>
      ) : (
        <Row className="text-center d-flex align-items-center justify-content-center mt-5">
          <Col lg={3} className="p-1">
            <Button type="button" onClick={onButton1Click} className="w-100">
              러시아 화장품 도매업 기업 리스트
            </Button>
          </Col> 
          <Col lg={3} className="p-1">
            <Button type="button" onClick={onButton2Click} className="w-100">
              러시아 식품 제조업 기업 리스트
            </Button>
          </Col>
          <Col lg={3} className="p-1">
            <Button type="button" onClick={onButton3Click} className="w-100">
              러시아 연구 기관 기업 리스트
            </Button>
          </Col>
        </Row>
      )}
    </Container>
  );
};
